module.exports = __webpack_public_path__ + "static/media/LK_White_Menu.04a46b68.svg";